import React from 'react';
import { CheckCircle2, Clock3, LogOut, Radio } from 'lucide-react';

function WaitingForQuestion({ className, onExit }) {
  return (
    <section
      className="
        flex min-h-[calc(100dvh-var(--ce-mobile-topbar-height))]
        flex-col items-center justify-center
        bg-[var(--section-bg)] 
        px-4 py-8 
        transition-all
      "
    >
      <div
        className="
          waiting-message 
          w-full max-w-3xl 
          bg-[var(--card-bg)] 
          shadow-md 
          rounded-lg 
          border border-[var(--border-color)]
          p-5 md:p-7
        "
      >
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-3">
            <div className="ce-live-loader" aria-hidden="true">
              <span>C</span>
            </div>
            <div>
              <h3 className="text-2xl font-semibold text-[var(--text-color)]">
                You are checked in
              </h3>
              {className && (
                <p className="mt-1 text-sm text-[var(--muted-color)]">{className}</p>
              )}
            </div>
          </div>
          <button
            type="button"
            onClick={onExit}
            className="inline-flex items-center justify-center gap-2 rounded-lg border px-4 py-2 text-sm font-semibold transition-colors"
            style={{
              borderColor: 'var(--border-color)',
              backgroundColor: 'var(--alt-bg)',
              color: 'var(--text-color)',
            }}
          >
            <LogOut size={16} aria-hidden="true" />
            Exit
          </button>
        </div>

        <div className="mt-5 grid gap-3 sm:grid-cols-3">
          <div className="rounded-lg border p-3" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)' }}>
            <div className="flex items-center gap-2 text-sm font-semibold text-[var(--text-color)]">
              <CheckCircle2 size={16} aria-hidden="true" />
              Checked in
            </div>
          </div>
          <div className="rounded-lg border p-3" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)' }}>
            <div className="flex items-center gap-2 text-sm font-semibold text-[var(--text-color)]">
              <Radio size={16} aria-hidden="true" />
              Live session
            </div>
          </div>
          <div className="rounded-lg border p-3" style={{ borderColor: 'var(--border-color)', backgroundColor: 'var(--alt-bg)' }}>
            <div className="flex items-center gap-2 text-sm font-semibold text-[var(--text-color)]">
              <Clock3 size={16} aria-hidden="true" />
              Waiting
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WaitingForQuestion;
